<div class="relative -mt-7 mb-7">
  <aux-route-tab-group [tabs]="tabs" [indexFn]="indexFn" />
</div>

@if (isQuarterCloseEnabled() && isClosingPanelEnabled()) {
  <aux-workflow-panel
    className="mb-6"
    [workflowName]="workflowName"
    [processing]="iCloseMonthsProcessing()!"
    [hasUserPermissions]="userHasLockDriversPermission()"
  />
}

<router-outlet />
